export default __webpack_public_path__ + "static/media/frying.05ba3028.gif";